import {
    screenResize,
    setDesktopView,
    setMobileView
  } from './actions'
  
  export {
    screenResize,
    setDesktopView,
    setMobileView,
    // thunks
    checkSwiperActive
  }

  // Thunks
const mobileMaxWidth = 768;
function checkSwiperActive(windowWidth){
  if(windowWidth < mobileMaxWidth){
    console.log('should be mobile')
    return dispatch =>{
      return setTimeout(()=>
        dispatch(setMobileView()), 500)
    } 
  }
  else{
    console.log('should be desktop')
    return dispatch =>{
      return setTimeout(()=>
        dispatch(setDesktopView()), 500)
    }
  }
}